// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__gepNY","Logo":"Auth_Logo__0L0Bm","Title":"Auth_Title__kE4lA","Error":"Auth_Error__mkZU8"};